/* src/app/shared/segment/segment.component.scss */
.elevation {
  position: absolute;
  width: 80px;
  height: 24px;
  background-repeat: no-repeat;
  background-size: contain;
  bottom: 32px;
  left: calc(24vw - 40px);
}
div {
  border-radius: 3vw;
  overflow: hidden;
}
/*# sourceMappingURL=segment.component.css.map */
